<div class="modal fade modal-confirmation" [ngClass]="device != 'desktop' ? 'app-modal' : ''" id="deleteModal" tabindex="-1" aria-labelledby="deleteModalLabel"
    aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h1 class="modal-title fs-5" id="deleteModalLabel">{{ 'CHECK.DELETE_MODAL_TITLE' | translate }}</h1>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-cancel" data-bs-dismiss="modal">{{ 'BUTTON.CANCEL' | translate }}</button>
                <button type="button" class="btn btn-confirm" data-bs-dismiss="modal" (click)="delete()">{{ 'LAYOUT_MODULE.DELETE' | translate }}</button>
            </div>
        </div>
    </div>
</div>